import React from "react";
import logo from "../assets/images/logo.svg";
import Error404 from "../assets/images/error404.svg";
import { useNavigate } from "react-router-dom";

function NotFoundPage() {
  let navigate = useNavigate();

  const BackToHome = () => {
    navigate(-1);
  };
  return (
    <>
      <div className="errorWrapper">
        <div className="errorLogo">
          <h1>اکسیژن سامان اراک</h1>
          <img src={logo} alt="logo" />
        </div>
        <div className="errorContent">
          <img src={Error404} alt="404" />
          <p>...صفحه مورد نظر یافت نشد</p>
          <div className="backBtn">
            <button onClick={BackToHome}>بازگشت</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFoundPage;
